import { useContext } from 'react';
import MultiTargetSelector from '../common/selection/MultiTargetSelector';
import { ctxReport } from '@/contexts/ReportCtx';

export default function ReportTargetSelector() {
  const reportCtx = useContext(ctxReport);
  if (!reportCtx) return;

  return (
    <MultiTargetSelector
      selectedTargets={reportCtx.selectedTargets}
      setSelectedTargets={reportCtx.setSelectedTargets}
      searchText={reportCtx.searchText}
      setSearchText={reportCtx.setSearchText}
      maxElementNumber={reportCtx.maxTargetNumber}
    />
  );
}
